import React, { useRef, useState } from "react";
import { GetDeviceDataSchemeByIdResponseDeviceDataSchemeDetail } from "../../../../models/response/deviceDataScheme/GetDeviceDataSchemeByIdResponse";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import { Helpers } from "../../../../helpers/Helpers";
import CustomTextInput from "../../../../components/CustomTextInput";
import Box from "../../../../components/Box";
import toast from "react-hot-toast";
import { storeAreYouSureModalCallback } from "../../../../redux/reducers/authSlice";
import { useDispatch } from "react-redux";

interface Props {
    deviceDataSchemeDetails: GetDeviceDataSchemeByIdResponseDeviceDataSchemeDetail[]
    setDeviceDataSchemeDetails: React.Dispatch<React.SetStateAction<GetDeviceDataSchemeByIdResponseDeviceDataSchemeDetail[]>>
}

const Details = ({
    deviceDataSchemeDetails,
    setDeviceDataSchemeDetails
}: Props) => {
    const dispatch = useDispatch();
    const deviceDataSchemeDetailsRef: any = useRef();
    const [isOpen, setIsOpen] = useState(false);
    const [deviceDataSchemeDetailId, setDeviceDataSchemeDetailId] = useState<string | undefined>(undefined);
    const [selectedType, setSelectedType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [formula, setFormula] = useState<string | undefined>(undefined);
    const [desc, setDesc] = useState<string | undefined>(undefined);

    const saveItem = () => {
        if (!selectedType || !formula || Helpers.isEmpty(formula)) {
            toast.error('Tüm alanları doldurunuz!');
            return;
        }

        if (deviceDataSchemeDetails.find(x => x.type == selectedType.value && x.deviceDataSchemeDetailId != deviceDataSchemeDetailId)) {
            toast.error('Bu UI Ad kullanılmaktadır!');
            return;
        }

        if (Helpers.isEmpty(deviceDataSchemeDetailId)) {
            var o: GetDeviceDataSchemeByIdResponseDeviceDataSchemeDetail = {
                deviceDataSchemeDetailId: Helpers.generateUUID(),
                description: desc,
                formula: formula,
                type: selectedType.value,
                isSelected: false,
            }

            setDeviceDataSchemeDetails([...deviceDataSchemeDetails, o])
        }
        else {
            setDeviceDataSchemeDetails(deviceDataSchemeDetails.map(function (x) {
                if (x.deviceDataSchemeDetailId == deviceDataSchemeDetailId) {
                    x.description = desc;
                    x.formula = formula;
                    x.type = selectedType.value;
                    x.isSelected = false;
                }

                return x;
            }))
        }

        setDeviceDataSchemeDetailId('');
        setSelectedType(undefined);
        setFormula('');
        setDesc('');
        setIsOpen(false);
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = deviceDataSchemeDetails.filter(x => x.isSelected)[0];

        setDeviceDataSchemeDetailId(o.deviceDataSchemeDetailId);
        setSelectedType({ label: o.type, value: o.type });
        setFormula(o.formula);
        setDesc(o.description);
        setIsOpen(true);
        scrollTo();
    }

    const setItemSelected = (_id: string) => {
        setDeviceDataSchemeDetails(deviceDataSchemeDetails.map(function (x) {
            if (x.deviceDataSchemeDetailId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const selectAll = () => {
        var isAllSelected = deviceDataSchemeDetails.length == deviceDataSchemeDetails.filter(x => x.isSelected).length;

        setDeviceDataSchemeDetails(deviceDataSchemeDetails.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const deleteItems = () => {
        setDeviceDataSchemeDetails(deviceDataSchemeDetails.filter(x => !x.isSelected));
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setDeviceDataSchemeDetailId('');
        setSelectedType(undefined);
        setFormula('');
        setDesc('');
        setIsOpen(false);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = deviceDataSchemeDetailsRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const types = [
        "KONTAK",
        "ROLANTI",
        "BATARYA_YUZDE",
        "SINYAL_GUCU",
        "GUNLUK_KM",
        "PEDAL_YUZDESI",
        "ANLIK_YAKIT",
        "MOTOR_DEVRI",
        "MOTOR_ISISI",
        "TOPLAM_KM",
        "GUNLUK_CALISMA_DAKIKASI",
        "GUNLUK_HARCANAN_YAKIT",
        "VOLTAJ",
        "ANI_HIZLANMA",
        "ANI_HIZLANMA_HIZI",
        "ANI_FREN",
        "ANI_DONUS",
        "RFID",
        "ANLIK_HIZ",
        "TACO_RFID_PART_1",
        "TACO_RFID_PART_2",
        "TACO_SURUCU_DURUM",
        "TACO_GUNLUK_TOPLAM_SURUS_SURESI",
        "TACO_KESINTISIZ_SURUS_SURESI",
        "TACO_DINLENME_SURESI",
        "TACO_MOLAYA_KALAN_SURE",
        "TACO_AKTIF_MOLADAN_KALAN_SURE",
        "TACO_24_SAATLIK_KALAN_SURUS_SURESI",
        "TACO_HAFTALIK_SURUS_SURESI",
        "TACO_AKTIF_KALAN_SURUS_SURESI",
        "TACO_HAFTALIK_KALAN_SURUS_SURESI",
        "TACO_DIGER_ISLER_SURESI",
        "AD_BLUE",
        "TACO_2_HAFTALIK_SURUS_SURESI",
        "TACO_2_HAFTALIK_KALAN_SURUS_SURESI",
        "TACO_UYARI_IHLAL"
    ];

    return (
        <div ref={deviceDataSchemeDetailsRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Detaylar</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className="row">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">UI Ad</label>
                                        <CustomSingleSelect
                                            selectedValue={selectedType}
                                            onChange={setSelectedType}
                                            onMenuOpen={async () => {
                                                return {
                                                    isSuccess: true,
                                                    data: types.map(function (x) {
                                                        return { label: x, value: x }
                                                    })
                                                }
                                            }}
                                            labelName='label'
                                            valueName='value'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Formül</label>
                                        <CustomTextInput value={formula} setValue={setFormula} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Açıklama</label>
                                        <CustomTextInput value={desc} setValue={setDesc} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={deviceDataSchemeDetails.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={deviceDataSchemeDetails.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>


                        <Box onClick={deviceDataSchemeDetails.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={deviceDataSchemeDetails.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={deviceDataSchemeDetails.filter(x => x.isSelected).length > 0 && deviceDataSchemeDetails.filter(x => x.isSelected).length == deviceDataSchemeDetails.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>UI Ad</th>
                                            <th>Formül</th>
                                            <th>Açıklama</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            deviceDataSchemeDetails.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            deviceDataSchemeDetails.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={() => setItemSelected(item.deviceDataSchemeDetailId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.type}</td>
                                                    <td>{item.formula}</td>
                                                    <td>{item.description}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default Details;